module.exports = __webpack_public_path__ + "static/krista-cec8c4b0adbc94b8ad6b7f0316afea0c.m4a";